module.exports = __webpack_public_path__ + "img/logo2.7a7e91eb.png";